import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IUserPicture } from '../../model/api/user-picture'; 
import { APP_CONFIG } from '../../app.config/app.config';
import { BaseService } from '../base/base.service';

@Injectable({
	providedIn: 'root'
})

export class UserPictureService extends BaseService<IUserPicture> {
    
    protected urlV2 = "/admin-v02/user-picture";

    constructor(@Inject(APP_CONFIG) private _config, private _http: HttpClient) {
        super(_config, _http)
    }

}
